import Vue from "vue";
import router from "@/router";
import axios from "axios";

const DEFAULT_ERROR_MESSAGE = "请求出现异常";
const NETWORK_ERROR_MESSAGE = "请求失败";
const UNAUTHORIZED_ERROR_MESSAGE = "登录已过期，请重新登录";
const FORBIDDEN_ERROR_MESSAGE = "错误的请求";
const NOT_FOUND_ERROR_MESSAGE = "请求资源不存在";
const SERVER_ERROR_MESSAGE = "服务器错误";

const errorAlert = (message) => {
  Vue.prototype.$alert({
    title: "请求错误",
    icon: "XIcon",
    text: message || DEFAULT_ERROR_MESSAGE,
    variant: "danger",
  });
};

const buildRejectedError = (message, rawError) => ({
  message: message || DEFAULT_ERROR_MESSAGE,
  rawError,
});

const getResponseMessage = (response, fallbackMessage) => {
  const message = response?.data?.message;
  return typeof message === "string" && message.trim()
    ? message
    : fallbackMessage;
};

const shouldShowErrorAlert = (config) => config?.showErrorAlert !== false;
const shouldUseAuth = (config) => config?.withAuth !== false;
const shouldRedirectToLogin = (config) =>
  shouldUseAuth(config) && router.currentRoute.name !== "Authorize";

var option = {
  baseURL: process.env.VUE_APP_BASE_URL,
  //baseURL: '/api',
  timeout: 8000,
};

const axiosIns = axios.create(option);
axiosIns.option = option;

axiosIns.interceptors.request.use(
  (config) => {
    var token = Vue.prototype.$getToken();
    if (shouldUseAuth(config) && token && token.token) {
      config.headers["Authorization"] = `Bearer ${token.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosIns.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (!error.response) {
      if (shouldShowErrorAlert(error.config)) {
        errorAlert(NETWORK_ERROR_MESSAGE);
      }
      return Promise.reject(buildRejectedError(NETWORK_ERROR_MESSAGE, error));
    }

    const { response } = error;
    let message = DEFAULT_ERROR_MESSAGE;

    if (response.status == 401) {
      if (shouldRedirectToLogin(error.config)) {
        router.push({ name: "Login" });
      }
      message = UNAUTHORIZED_ERROR_MESSAGE;
    } else if (response.status == 403) {
      message = getResponseMessage(response, FORBIDDEN_ERROR_MESSAGE);
    } else if (response.status == 404) {
      message = getResponseMessage(response, NOT_FOUND_ERROR_MESSAGE);
    } else if (response.status == 500) {
      message = getResponseMessage(response, SERVER_ERROR_MESSAGE);
    } else {
      message = getResponseMessage(response, DEFAULT_ERROR_MESSAGE);
    }

    if (shouldShowErrorAlert(error.config)) {
      errorAlert(message);
    }
    return Promise.reject(buildRejectedError(message, error));
  }
);

Vue.prototype.$http = axiosIns;
Vue.prototype.$baseURL = option.baseURL;
Vue.prototype.$transformRequest = function(data) {
  let ret = "";
  for (let it in data) {
    ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
  }
  return ret;
};

export default axiosIns;
